"use strict";
/* eslint-disable no-useless-escape */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmailValid = void 0;
const EMAIL_REGEX = /^[a-zA-Z0-9!#$%&\'*+\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
function isEmailValid(email) {
    return EMAIL_REGEX.test(email);
}
exports.isEmailValid = isEmailValid;
